export default __webpack_public_path__ + "static/media/before_payment.834bc2a9.png";